// ============================================================
// FILE: src/lib/api.js  →  BUNDLED DATA LOADER
// This fully-static site loads its products & articles from
// JSON files bundled inside the build. Form submissions go
// directly to Web3Forms (see InquiryForm.jsx / Footer.jsx) —
// there is NO backend server. YOU RARELY NEED TO EDIT THIS FILE.
// ============================================================

import axios from "axios";

// Branded PDF product catalogue — bundled inside the site (public/downloads),
// so it works on any static hosting with no server needed.
export const CATALOGUE_URL = "/downloads/Evolve-Trade-Logistics-Product-Catalogue.pdf";

// ===== PRODUCTS & ARTICLES — BUNDLED STATIC DATA =====
// Products and blog articles are packed INSIDE the website as JSON
// files (/data/products.json, /data/posts.json), so they always load
// correctly on any hosting — no live server needed.
let _productsPromise;
const loadProducts = () => (_productsPromise ??= axios.get("/data/products.json").then((r) => r.data));
let _postsPromise;
const loadPosts = () => (_postsPromise ??= axios.get("/data/posts.json").then((r) => r.data));

export const api = {
  products: (category) =>
    loadProducts().then((all) => (category ? all.filter((p) => p.category === category) : all)),
  product: (slug) =>
    loadProducts().then((all) => {
      const found = all.find((p) => p.slug === slug);
      if (!found) throw new Error("Product not found");
      return found;
    }),
  posts: () => loadPosts(),
  post: (slug) =>
    loadPosts().then((all) => {
      const found = all.find((p) => p.slug === slug);
      if (!found) throw new Error("Post not found");
      return found;
    }),
};
